import { render, staticRenderFns } from "./ForgatPwd.vue?vue&type=template&id=7c9dcd66"
import script from "./ForgatPwd.vue?vue&type=script&lang=js"
export * from "./ForgatPwd.vue?vue&type=script&lang=js"
import style0 from "./ForgatPwd.vue?vue&type=style&index=0&id=7c9dcd66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports